import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FollowShipment } from '@app/models/follow-shipment';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class FollowShipmentService {
  constructor(private http: HttpClient) {}

  get(FollowId: number) {
    return this.http.get<FollowShipment[]>(
      `${API}follows/${FollowId}/shipments`
    );
  }

  getCounter(FollowId: number) {
    return this.http.get<FollowShipment[]>(
      `${API}follows/${FollowId}/shipmentsCounter`
    );
  }

  create(FollowId: number, data: any) {
    return this.http.post<FollowShipment[]>(
      `${API}follows/${FollowId}/shipments`,
      data
    );
  }

  delete(followId, shipmentId) {
    return this.http.delete<FollowShipment>(
      `${API}follows/${followId}/shipments/${shipmentId}`
    );
  }

  update(FollowId: number, data: any) {
    const ShipmentId = data.ShipmentId;

    // console.log("FollowId: ", FollowId);
    // console.log(data);

    return this.http.put<FollowShipment[]>(
      `${API}follows/${FollowId}/shipments/${ShipmentId}`,
      data
    );
  }

  updateMany(FollowId: number, data: any) {
    // const ShipmentId = data.ShipmentId;

    // console.log('FollowId: ', FollowId);
    // console.log(data);

    return this.http.put<FollowShipment[]>(
      `${API}follows/${FollowId}/shipments`,
      data
    );
  }
}
